import clsx from "clsx";
import React, { useState } from "react";
import Switch from "react-switch";

import * as userSelectors from "../../../../selectors/user";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import * as axiosInstance from "../../../../services/axiosInstance";
import * as userActions from "../../../../action/user";
import { useDispatch } from "react-redux";

function EmailNotificationSettings({ data }) {
  const [loading,setLoading] = useState(false);
  const dispatch = useDispatch();
  const setOffEmail = userSelectors.getNotificationSettingsESetoffEmail(data);
  const eWithdrawalEmail =
    userSelectors.getNotificationSettingsEWithdrawalEmail(data);
  const ePaymentEmail =
    userSelectors.getNotificationSettingsEPaymentEmail(data);
  const eDepositEmail =
    userSelectors.getNotificationSettingsEDepositEmail(data);
  const dailySummaryEmail =
    userSelectors.getNotificationSettingsEDailySummaryEmail(data);
  const handleChange = (value, type) => {
    setValue(type, value);
  };
  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onSubmit",
    defaultValues: {
      e_setoff_email: setOffEmail,
      e_withdrawal_email: eWithdrawalEmail,
      e_payment_email: ePaymentEmail,
      e_deposit_email: eDepositEmail,
      daily_summary_email: dailySummaryEmail,
    },
    // reValidateMode: "onChange",
  });
  const onSubmit = async (values) => {
    try {
      setLoading(true);
      const response = await axiosInstance.patch(
        "clientarea/profile/notification-setting",
        values,
        true,
        false,
        "Notification Changed Successfully",
      );
      dispatch(userActions.updateUserDetailNotification(response.data));
    } catch (e) {
      console.log("ee" + e);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="shadow mt-3">
      <div className={clsx("custom-card-label-container")}>
        <h2>Email Notification Settings</h2>
      </div>
      <div className="profile-other-info position-relative">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="email-notification-item-container">
            <div className="email-notification-item-title">
              E-Setoff Email Notification
            </div>
            <div className="d-flex align-items-center">
              <Controller
                control={control}
                name="e_setoff_email"
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <Switch
                    className="mx-2"
                    onChange={(value) => handleChange(value, "e_setoff_email")}
                    checked={value}
                  />
                )}
              />
            </div>
          </div>
          <div className="email-notification-item-container">
            <div className="email-notification-item-title">
              E-Payment Email Notification
            </div>
            <div className="d-flex align-items-center">
              {/*<LoadingOverlay isSemiLoading={true} loading={true}></LoadingOverlay>*/}
              <Controller
                control={control}
                name="e_payment_email"
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <Switch
                    className="mx-2"
                    onChange={(value) => handleChange(value, "e_payment_email")}
                    checked={value}
                  />
                )}
              />
            </div>
          </div>
          <div className="email-notification-item-container">
            <div className="email-notification-item-title">
              E-Withdrawal Email Notification
            </div>
            <div className="d-flex align-items-center">
              {/*<LoadingOverlay isSemiLoading={true} loading={true}></LoadingOverlay>*/}
              <Controller
                control={control}
                name="e_withdrawal_email"
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <Switch
                    className="mx-2"
                    onChange={(value) =>
                      handleChange(value, "e_withdrawal_email")
                    }
                    checked={value}
                  />
                )}
              />
            </div>
          </div>
          <div className="email-notification-item-container">
            <div className="email-notification-item-title">
              E-Deposit Email Notification
            </div>
            <div className="d-flex align-items-center">
              {/*<LoadingOverlay isSemiLoading={true} loading={true}></LoadingOverlay>*/}
              <Controller
                control={control}
                name="e_deposit_email"
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <Switch
                    className="mx-2"
                    onChange={(value) => handleChange(value, "e_deposit_email")}
                    checked={value}
                  />
                )}
              />
            </div>
          </div>
          <div className="email-notification-item-container">
            <div className="email-notification-item-title">
              Daily Summary Notification
            </div>
            <div className="d-flex align-items-center">
              {/*<LoadingOverlay isSemiLoading={true} loading={true}></LoadingOverlay>*/}
              <Controller
                control={control}
                name="daily_summary_email"
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <Switch
                    className="mx-2"
                    onChange={(value) =>
                      handleChange(value, "daily_summary_email")
                    }
                    checked={value}
                  />
                )}
              />
            </div>
          </div>
          <button
            className={clsx("btn btn-primary btn-fill mt-4 mb-2")}
            type="submit"
          >
            Submit
          </button>
        </Form>

        <LoadingOverlay loading={loading}></LoadingOverlay>
      </div>
    </div>
  );
}

export default EmailNotificationSettings;
